// extracted by mini-css-extract-plugin
export default {"alert":"UI_ITOModuleAlert_alert__AMnwF","button":"UI_ITOModuleAlert_button__XdbXM","iconsDown":"UI_ITOModuleAlert_iconsDown__-EvEG","iconsUp":"UI_ITOModuleAlert_iconsUp__PpFr8"};